import React from "react";
import { FaArrowRight, FaCircleCheck } from "react-icons/fa6";
import { BTN_SIZE, Container, H2_SIZE } from "../home/ui";

// Banner background (soft blue panel with faded leaves on both sides).
// File: public/img/maintenance-cta.jpg (1980x320). On desktop (lg+) the box keeps the image ratio so the leaves are
// never cropped and sizes use vw; smaller screens use the same image as a cover background.
const ctaBg = "/img/maintenance-cta.jpg";

const MaintCta = () => (
  <section className="bg-white py-[40px] lg:py-[56px]">
    <Container className="max-w-[1240px]">
      <div
        className="relative overflow-hidden rounded-[22px] bg-[#ECF3FD] bg-cover bg-center bg-no-repeat px-[24px] py-[36px] sm:px-[48px] lg:flex lg:aspect-[1980/320] lg:items-center lg:rounded-none lg:bg-[length:100%_100%] lg:px-[14%] lg:py-0"
        style={{ backgroundImage: `url(${ctaBg})` }}
      >
        <div className="grid w-full items-center gap-[28px] lg:grid-cols-[minmax(0,1.35fr)_minmax(0,0.65fr)] lg:gap-[3%]">
          <div>
            <h2 className={`font-extrabold tracking-tight text-[#0B1A4A] ${H2_SIZE}`}>
              Let&apos;s Keep Your Website
              {" "}<br />
              Running at Its Best
            </h2>
            <p className="mt-[12px] max-w-[520px] text-[15px] leading-[1.6] text-slate-600 lg:mt-[clamp(6px,0.8vw,12px)] lg:text-[clamp(12.5px,1.05vw,15px)]">
              Get reliable website maintenance and support from our expert team. Focus on your business, we&apos;ll take care of
              the rest.
            </p>
          </div>

          <div className="max-sm:flex max-sm:flex-col max-sm:items-center">
            <a
              href="/contact-us"
              className={`group inline-flex items-center rounded-full bg-[#1E5BFF] font-medium text-white shadow-[0_14px_30px_-14px_rgba(30,91,255,0.8)] transition hover:brightness-110 ${BTN_SIZE}`}
            >
              Get a Free Consultation
              <FaArrowRight className="text-[13px] transition group-hover:translate-x-1" />
            </a>
            <ul className="mt-[16px] space-y-[8px] lg:mt-[clamp(8px,1vw,16px)]">
              {["No long-term contract", "Quick response time"].map((t) => (
                <li key={t} className="flex items-center gap-[10px] text-[14px] text-[#0B1A4A] lg:text-[clamp(12px,1vw,14px)]">
                  <FaCircleCheck className="text-[16px] text-[#4F8BFF]" />
                  {t}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Container>
  </section>
);

export default MaintCta;
